import { cloneVNode, defineComponent, h } from 'vue';
import { Tooltip } from 'ant-design-vue';
import { useCompactViewport } from '@/composables/useCompactViewport';

export default defineComponent({
  name: 'AppTooltip',
  inheritAttrs: false,
  setup(_, { attrs, slots }) {
    const compact = useCompactViewport();
    return () => {
      const mobile =
        compact.value ||
        (typeof window !== 'undefined' && window.matchMedia?.('(hover: none)').matches);
      return h(Tooltip, mobile ? { ...attrs, trigger: [], open: false } : attrs, {
        ...slots,
        default: () =>
          slots
            .default?.()
            .map((child) =>
              mobile && typeof attrs.title === 'string' && !child.props?.['aria-label']
                ? cloneVNode(child, { 'aria-label': attrs.title })
                : child,
            ),
      });
    };
  },
});
